import { Component } from 'react';

class ErrorBoundary extends Component {
  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'development') {
      window.location.assign('/clapply/cl/CLError.action');
    }
    // You can also log error messages to an error reporting service here
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
